// JsFromRoutes CacheKey 89b4580883c3dc55d8b9cc06cc41e909
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  profile: /* #__PURE__ */ definePathHelper('get', '/users/:id/profile'),
  galleries: /* #__PURE__ */ definePathHelper('get', '/users/:id/galleries'),
  wall: /* #__PURE__ */ definePathHelper('get', '/users/:id/wall'),
  stories: /* #__PURE__ */ definePathHelper('get', '/users/:id/stories'),
  friends: /* #__PURE__ */ definePathHelper('get', '/users/:id/friends'),
  testimonials: /* #__PURE__ */ definePathHelper('get', '/users/:id/testimonials'),
  conversations: /* #__PURE__ */ definePathHelper('get', '/users/:id/conversations'),
  conversationsGet: /* #__PURE__ */ definePathHelper('get', '/users/:id/conversations'),
  searches: /* #__PURE__ */ definePathHelper('get', '/users/:id/searches'),
  trophies: /* #__PURE__ */ definePathHelper('get', '/users/:id/trophies'),
  gallery: /* #__PURE__ */ definePathHelper('get', '/users/:id/gallery(/:gallery_id)'),
  videos: /* #__PURE__ */ definePathHelper('get', '/users/:id/videos'),
  index: /* #__PURE__ */ definePathHelper('get', '/users'),
  show: /* #__PURE__ */ definePathHelper('get', '/users/:id'),
}
